import React from 'react'
import styled from "@emotion/styled";
import Text from "../../components/text/Text";
import Colors from "../../styles/Colors";
import {keyframes} from "@emotion/core";

export const NotificationContext = React.createContext({
    showNotification: (notification: Notification): void => {
    },
})

export interface Notification {
    title?: string,
    message?: string,
    expire?: number,
    type?: "success" | "error" | "warning" | "info",
}

class NotificationProvider extends React.Component<any, any> {
    private maxNotification = 5

    constructor(props: any) {
        super(props)

        this.state = {
            notificationPool: [],
        }

        this.showNotification = this.showNotification.bind(this)
        this.renderNotification = this.renderNotification.bind(this)
    }

    addNotification = (newNotification: Notification) => {
        this.setState({
            notificationPool: [
                ...this.state.notificationPool,
                newNotification,
            ]
        })
    }

    openNotification = (notifIf: number, expire: number) => {
        // setTimeout(this.closeNotification.bind(this, notifIf), expire + 750)
    }

    closeNotification = (index: number) => {
        /*console.log([
            ...this.state.notificationPool.slice(0, index),
            ...this.state.notificationPool.slice(index + 1),
        ])*/

        /*const updatedNotificationPool = [
            ...this.state.notificationPool.slice(0, index),
            ...this.state.notificationPool.slice(index),
        ]*/

        /*this.setState({
            notificationPool: updatedNotificationPool,
        })*/
    }

    renderNotification = (
        {
            title = "",
            message = "",
            expire = 5000,
            type = "info",
        }: Notification,
        index: number,
    ) => {
        this.openNotification(index, expire)

        return (
            <NotificationContainer
                key={index}
                expire={expire}
            >
                <NotificationContent>
                    {title && <Text type={"h6"}>{title}</Text>}

                    {message && <Text>{message}</Text>}
                </NotificationContent>

                <NotificationTimerContainer>
                    <NotificationTimer
                        color={type}
                        expire={expire}
                    />
                </NotificationTimerContainer>
            </NotificationContainer>
        )
    }

    showNotification = (notification: Notification): void => {
        this.addNotification(notification)
    }

    render() {
        return <NotificationContext.Provider value={{showNotification: this.showNotification}}>
            <Container>
                <NotificationListContainer>
                    {this.state.notificationPool.map((item: Notification, index: number) => this.renderNotification(item, index))}
                </NotificationListContainer>

                {this.props.children}
            </Container>
        </NotificationContext.Provider>
    }
}


export default NotificationProvider

const Container = styled.div`
  position: relative;
`

const NotificationListContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50px;
  z-index: 10000;
`

interface NotificationContainerProps {
    expire: number,
}

const notificationOpenKeyframes = keyframes`
  0% {
    left: -300px;
  }
  
  100% {
    left: 20px;
  }
`

const notificationCloseKeyframes = keyframes`
  0% {
    left: 20px;
  }
  
  50% {
    left: -300px;
  }
  
  100% {
    left: -3000px;
    position: absolute;
  }
`


const NotificationContainer = styled.div<NotificationContainerProps>`
  display: flex;
  flex-direction: column;
  left: 20px;
  position: relative;
  background-color: ${Colors.white};
  box-shadow: ${Colors.dropdownShadow};
  z-index: 10000;
  border-radius: 5px;
  margin-top: 20px;
  overflow: hidden;
 
  animation: ${notificationOpenKeyframes} 250ms linear 0ms, ${notificationCloseKeyframes} 500ms linear ${props => (props.expire + 500) + "ms"};
  animation-fill-mode: forwards;
  
  @media (max-width: 768px) {
    max-width: calc(100% - 40px);
  }
`

const NotificationContent = styled.div`
  width: 100%;
  padding: 10px 15px;
  
  p, h6 {
    text-align: start;
  }
  
  h6 {
     margin-bottom: 5px; 
     font-size: 16px;
  }
  
  p {
    font-size: 14px;
  }
`

const NotificationTimerContainer = styled.div`
  width: 100%;
  height: 5px;
  z-index: 11000;
`

interface NotificationTimerProps {
    expire: number,
    color: string,
}

const notificationTimerKeyframes = keyframes`
  0% {
    width: 100%;
  }
  
  100% {
    width: 0;
  }
`

const NotificationTimer = styled.div<NotificationTimerProps>`
  // @ts-ignore
  background-color: ${props => Colors[props.color]};
  width: 100%;
  height: 100%;
  
  animation: ${notificationTimerKeyframes} linear;
  animation-delay: 250ms;
  animation-duration: ${props => props.expire + "ms"};
  animation-fill-mode: forwards;
`
